// Dial-code country list for PhoneInput — placeholder until a real
// country service lands. Values stay literal (mock-data convention).

export interface Country {
  /** ISO 3166-1 alpha-2 code. */
  iso: string;
  /** Short display code shown in the dial badge (per design, e.g. KSA). */
  code: string;
  /** Dial code including the leading +. */
  dial: string;
  label: string;
  flagColor: string;
}

export const countries: Country[] = [
  { iso: 'SA', code: 'KSA', dial: '+966', label: 'Saudi Arabia', flagColor: '#0E7A3B' },
  { iso: 'PK', code: 'PAK', dial: '+92', label: 'Pakistan', flagColor: '#01411C' },
];

export const defaultCountry = countries[0];

/** Country picker options, in the design's order (Gulf first, then wider).
 *  Separate from `countries` above, which exists only to feed PhoneInput's
 *  dial-code badge and carries just the two dialable markets.
 *
 *  `value` is what is WRITTEN to the backend — the English name, since the
 *  contract types `country` as a free string — while the label is translated,
 *  the same split the formats vocabularies use. */
export interface CountryOption {
  value: string;
  labelKey: string;
}

export const countryOptions: CountryOption[] = [
  { value: 'United Arab Emirates', labelKey: 'select_united_arab_emirates' },
  { value: 'Saudi Arabia', labelKey: 'select_saudi_arabia' },
  { value: 'Qatar', labelKey: 'select_qatar' },
  { value: 'Kuwait', labelKey: 'select_kuwait' },
  { value: 'Egypt', labelKey: 'select_egypt' },
  { value: 'Jordan', labelKey: 'select_jordan' },
  { value: 'United Kingdom', labelKey: 'select_united_kingdom' },
  { value: 'United States', labelKey: 'select_united_states' },
  { value: 'Pakistan', labelKey: 'select_pakistan' },
];
